import { ROLE_ADMIN_ID } from 'model/Role';

/**
 * Resolves whether the current user can manage global revision templates.
 */
export function canManageTemplatesGlobally(roleId: number | null, hasGlobalManageTemplatesPermission: boolean) {
  return roleId === ROLE_ADMIN_ID || hasGlobalManageTemplatesPermission;
}
